/* eslint-disable */
import React from "react";
import MainCarousel from "../components/MainCarousel";
import Banner from "../components/Banner";
import ProductCarousel from "../components/ProductCarousel";
import ProductCategory from "../components/ProductCategory";
import Banner21 from "../assets/banner21.png";
// import { Typography } from '@mui/material';

const styles = {
  heading: {
    color: '#3f51b5', // Initial color
    transition: 'color 0.3s ease',
    '&:hover': {
      color: '#ff4081', // Color on hover
    },
  },
};

export default function Home() {
  return (
    <div>
      <MainCarousel />
      <Banner />
      <div style={{ margin: "20px" }}>
        <ProductCategory />
      </div>
      <div style={{ margin: "20px" }}>
        <ProductCarousel heading={"Featured Items"} headingStyle={styles.heading} />
      </div>
      <div style={{ overflowX: "hidden" }}>
        <img className="ImageDesing" src={Banner21} alt="Banner" />
      </div>
      <div style={{ margin: "20px" }}>
        <ProductCarousel heading={"Best Selling Books"} headingStyle={styles.heading} />
      </div>
      <div style={{ margin: "20px" }}>
        <ProductCarousel heading={"Popular Books"} headingStyle={styles.heading} />
      </div>
      <div style={{ margin: "20px" }}>
        <ProductCarousel heading={"Special Offers"} headingStyle={styles.heading} />
      </div>
    </div>
  );
}
